import styled from 'styled-components';

export const StyledInputsEditPanelWrapper = styled.div`
    width: 100%;
    max-width: 750px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;

    @media only screen and (max-width: 1334px) {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    @media only screen and (max-width: 926px) {
        padding-top: 30px;
    }
`;
